import * as types from './types';
import { PosModeLetterTemplateFilters } from 'Pages/letterhistoryreport/constants';

const initalState = {
  letterTemplates: [],
  students: { totalPages: 0, result: [] },
  studentsLoading: false,
  report: null,
  loading: false,
  templateLoading: false,
  error: null,
};

export default (state = initalState, { payload, type }) => {
  switch (type) {
    case types.LETTER_HISTORY_GET_LETTER_TEMPLATES:
      const letterTemplates = payload
        .filter(
          t =>
            t.LetterCategoryId ===
              PosModeLetterTemplateFilters.LetterCategoryId &&
            t.LanguageId === PosModeLetterTemplateFilters.LanguageId
        )
        .map(t => {
          return { text: t.Description, value: t.Id, key: t.Id };
        });

      return {
        ...state,
        letterTemplates: letterTemplates,
      };

    case types.LETTER_HISTORY_REPORT:
      return {
        ...state,
        report: payload,
      };

    case types.LETTER_HISTORY_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.LETTER_HISTORY_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    case types.LETTER_HISTORY_FETCHING:
      return {
        ...state,
        loading: payload,
      };

    case types.LETTER_HISTORY_FETCH_STUDENTS:
      return {
        ...state,
        students: { totalPages: payload.TotalPages, result: payload.Result },
      };

    case types.LETTER_HISTORY_STUDENTS_LOADING:
      return {
        ...state,
        studentsLoading: payload,
      };

    case types.LETTER_HISTORY_CLEAR_STUDENTS:
      return {
        ...state,
        students: { totalPages: 0, result: [] },
      };

    case types.LETTER_HISTORY_GET_LETTER_TEMPLATES_LOADING:
      return { ...state, templateLoading: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/letterhistoryreport/state/letterhistoryreport/reducer.js